import React, { useRef } from "react";
import "./ageInputField.scss";

const AgeInputField = (props) => {
  const {
    name,
    value,
    disabled,
    bottomLabel,
    showDropdown,
    dropdownList,
    handleShowDropdown,
    handleBlockInvalidChar,
    handleInputChange,
    handleSelect,
    operationHandler,
  } = props;
  let myref = useRef(null);
  return (
    <div style={{ position: "relative" }}>
      <div>
        <div className="age-input-filed">
          <input
            className="age-input"
            type={"number"}
            name={name}
            value={value}
            disabled={disabled}
            onClick={handleShowDropdown}
            onKeyDown={handleBlockInvalidChar}
            onChange={handleInputChange}
            ref={myref}
          />
          <div
            className={`age-input-arrow ${
              disabled && "disable-age-input-arrow"
            }`}
          >
            <i
              className="fa fa-caret-up"
              onClick={() => {
                myref.current.focus();
                operationHandler(name, 1);
              }}
            ></i>
            <i
              className="fa fa-caret-down"
              onClick={() => {
                myref.current.focus();
                operationHandler(name, -1);
              }}
            ></i>
          </div>
        </div>
        <div className="bottom-label my-2">{bottomLabel}</div>
      </div>
      {showDropdown && (
        <div className="age-picker-dropdown">
          {dropdownList &&
            dropdownList.map((data) => (
              <div
                className="age-picker-dropdown-item"
                onClick={() => handleSelect(name, data)}
              >
                {data}
              </div>
            ))}
        </div>
      )}
    </div>
  );
};

export default AgeInputField;
